module.exports = __webpack_public_path__ + "static/thanx-raw-891e462decaa40ce91fb33571a92e669.jpg";